import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import OpenChatBot from '~/components/layout/Chatbot';
import Header from '~/components/layout/Header';
import NavigationCard from '~/components/pages/MyAccount/NavigationCard';
import SideBar from '~/components/layout/Sidebar';
import RatingModal from '~/pages/Rating';
import { isAuthorizedCore } from '~/services/coreConfig';

import { verifyRoles } from '~/utils/functions/verifyRoles';
import {
  Container,
  Content,
  HeaderContainer,
  NavigationContainer,
  PageContainer,
  DivisionCards,
} from './styles';

export default function MyAccount() {
  const stores = useSelector(state => state.economicGroupReducer.stores);
  const roles = useSelector(state => state.rolesReducer.roles);
  const classificationReducer = useSelector(
    state => state.classificationReducer,
  );

  const [showModal, setShowModal] = useState(false);
  const [lessThan3Roles, setLessThan3Roles] = useState(false);
  const [historyPath, setHistoryPath] = useState('/consultor-comercial');

  useEffect(() => {
    const rolesArray = [];
    ['BOLETOS', 'NOTAS_FISCAIS', 'VALE_GAS', 'CONTRATOS'].map(element => {
      if (verifyRoles(roles, element)) {
        rolesArray.push(element);
      }
      return ''
    });
    if (rolesArray.length < 3) {
      setLessThan3Roles(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const core = localStorage.getItem('core');
    const isAuthorizedCoreVisit = isAuthorizedCore(core);
    if (isAuthorizedCoreVisit) {
      setHistoryPath('/historico-visitas');
    } else {
      setHistoryPath('/consultor-comercial');
    }
  }, []);

  return (
    <PageContainer>
      <SideBar
        menuSelected={'Minha Conta'}
        hasPendenciOn={classificationReducer.pendenciesOn}
      >
        <Container>
          <RatingModal
            showModal={showModal}
            setShowModal={setShowModal}
            valueRating={0}
            valueComment={''}
          />
          <Content>
            <HeaderContainer>
              <Header stores={stores} />
            </HeaderContainer>
            {lessThan3Roles ? (
              <NavigationContainer roles={roles} verifyRoles={verifyRoles}>
                <DivisionCards>
                  {verifyRoles(roles, 'BOLETOS') && (
                    <NavigationCard
                      path="/boletos"
                      title="2ª via de Boleto"
                      icon="barcode.svg"
                    />
                  )}
                  {verifyRoles(roles, 'NOTAS_FISCAIS') && (
                    <NavigationCard
                      path="/notas"
                      title="2ª via de Nota Fiscal"
                      icon="receipt.svg"
                    />
                  )}
                  {verifyRoles(roles, 'VALE_GAS') && (
                    <NavigationCard
                      path="/valegas"
                      title="Vale Gás"
                      icon="vale.svg"
                    />
                  )}
                  {verifyRoles(roles, 'TROCAS') && (
                    <NavigationCard
                      path="/trocas"
                      title="Trocas"
                      icon="vale.svg"
                    />
                  )}
                  {verifyRoles(roles, 'CONTRATOS') && (
                    <NavigationCard
                      path="/contratos"
                      title="Contratos e Adendos"
                      icon="Contratos_e_adendos.svg"
                    />
                  )}
                  <NavigationCard
                    path="/avaliacao"
                    title="Sugestões e reclamações"
                    icon="star_rate.svg"
                    setShowModal={setShowModal}
                  />
                  {verifyRoles(roles, 'CONSULTOR_COMERCIAL') && (
                    <NavigationCard
                      path={historyPath}
                      title="Histórico de visitas"
                      icon="consultor.png"
                    />
                  )}
                  <NavigationCard
                    path="/editar-perfil"
                    title="Meu perfil"
                    icon="user_perfil.svg"
                  />
                </DivisionCards>
              </NavigationContainer>
            ) : (
              <NavigationContainer roles={roles} verifyRoles={verifyRoles}>
                <DivisionCards>
                  {verifyRoles(roles, 'BOLETOS') && (
                    <NavigationCard
                      path="/boletos"
                      title="2ª via de Boleto"
                      icon="barcode.svg"
                    />
                  )}
                  {verifyRoles(roles, 'NOTAS_FISCAIS') && (
                    <NavigationCard
                      path="/notas"
                      title="2ª via de Nota Fiscal"
                      icon="receipt.svg"
                    />
                  )}
                  {verifyRoles(roles, 'VALE_GAS') && (
                    <NavigationCard
                      path="/valegas"
                      title="Vale Gás"
                      icon="vale.svg"
                    />
                  )}
                  <NavigationCard
                    path="/editar-perfil"
                    title="Meu perfil"
                    icon="user_perfil.svg"
                  />
                </DivisionCards>
                <DivisionCards>
                  {verifyRoles(roles, 'TROCAS') && (
                    <NavigationCard
                      path="/trocas"
                      title="Trocas"
                      icon="trocas_gray.png"
                    />
                  )}
                  {verifyRoles(roles, 'CONTRATOS') && (
                    <NavigationCard
                      path="/contratos"
                      title="Contratos e Adendos"
                      icon="Contratos_e_adendos.svg"
                    />
                  )}
                  <NavigationCard
                    path="/avaliacao"
                    title="Sugestões e reclamações"
                    icon="star_rate.svg"
                    setShowModal={setShowModal}
                  />
                  {verifyRoles(roles, 'CONSULTOR_COMERCIAL') && (
                    <NavigationCard
                      path={historyPath}
                      title="Histórico de visitas"
                      icon="consultor.png"
                    />
                  )}
                </DivisionCards>
              </NavigationContainer>
            )}
          </Content>
        </Container>
        <OpenChatBot />
      </SideBar>
    </PageContainer>
  );
}
